"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiImageEmbeddedOverview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const components_1 = require("../../components");
const useSubmitHandler_1 = require("../../hooks/useSubmitHandler");
const AiImageOverview_style_1 = require("./AiImageOverview.style");
const AiImageStyles_1 = require("./AiImageStyles");
function AiImageEmbeddedOverview({ labels, onPromptSubmit, insertNewAsset, imageStyles, imageSizes, outputFormat, imageInformation, onStatusChange, onCancelFlow, allowRegenerate, onFlowInformationChange, previewUrl, }) {
    const [view, setView] = (0, react_1.useState)('edit');
    const [selectedStyle, setSelectedStyle] = (0, react_1.useState)(imageStyles[0].value);
    const [selectedImageSize, setSelectedImageSize] = (0, react_1.useState)(imageSizes === null || imageSizes === void 0 ? void 0 : imageSizes[0]);
    const [stylesOpened, setStylesOpened] = (0, react_1.useState)(false);
    const { prompt, setPrompt, textAreaRef, status, result, onSubmit, onClear, onCancel: onCancelSubmit, } = (0, useSubmitHandler_1.useSubmitHandler)(onPromptSubmit, onStatusChange);
    (0, react_1.useEffect)(() => {
        if (!imageInformation)
            return;
        const style = imageInformation.style || 'supriseme';
        const size = imageInformation.size || '1024x1024';
        setPrompt(imageInformation.prompt);
        setSelectedStyle(style);
        setSelectedImageSize(imageSizes === null || imageSizes === void 0 ? void 0 : imageSizes.find((item) => item.value === size));
    }, [setPrompt, imageInformation, imageSizes]);
    (0, react_1.useEffect)(function autoSubmit() {
        if (!imageInformation)
            return;
        const style = imageInformation.style || 'supriseme';
        const size = imageInformation.size || '1024x1024';
        imageInformation.submit &&
            onSubmit(imageInformation.prompt, {
                style,
                size,
            });
    }, []);
    (0, react_1.useEffect)(() => {
        !allowRegenerate && !result && !previewUrl && (onCancelFlow === null || onCancelFlow === void 0 ? void 0 : onCancelFlow());
        (result || previewUrl) && setView('preview');
    }, [allowRegenerate, result, previewUrl]);
    const handleSeeMoreStyles = (0, react_1.useCallback)(() => {
        if (result && status === 'loading')
            setStylesOpened(false);
        setStylesOpened((prev) => !prev);
    }, [result, status]);
    const onCancel = (0, react_1.useCallback)(() => {
        if (result) {
            setView('preview');
        }
        else if (status === 'idle' && onCancelFlow) {
            onCancelFlow();
        }
        else {
            onCancelSubmit();
        }
    }, [result, onCancelFlow, onCancelSubmit, status]);
    const imagePreview = outputFormat === 'base64' ? `data:image/png;base64, ${result}` : result;
    const handlePromptChange = (0, react_1.useCallback)((prompt) => {
        setPrompt(prompt);
        const aiImageData = {
            flowType: 'image',
            prompt,
            style: selectedStyle,
            size: selectedImageSize === null || selectedImageSize === void 0 ? void 0 : selectedImageSize.value,
            submit: false,
        };
        onFlowInformationChange === null || onFlowInformationChange === void 0 ? void 0 : onFlowInformationChange(aiImageData);
    }, [setPrompt, selectedStyle, selectedImageSize, onFlowInformationChange]);
    const handleStyleChange = (0, react_1.useCallback)((style) => {
        setSelectedStyle(style);
        const aiImageData = {
            flowType: 'image',
            prompt: prompt || '',
            style,
            size: selectedImageSize === null || selectedImageSize === void 0 ? void 0 : selectedImageSize.value,
            submit: false,
        };
        onFlowInformationChange === null || onFlowInformationChange === void 0 ? void 0 : onFlowInformationChange(aiImageData);
    }, [setSelectedStyle, prompt, selectedImageSize, onFlowInformationChange]);
    const handleSizeChange = (0, react_1.useCallback)((size) => {
        setSelectedImageSize(size);
        const aiImageData = {
            flowType: 'image',
            prompt: prompt || '',
            style: selectedStyle,
            size: size.value,
            submit: false,
        };
        onFlowInformationChange === null || onFlowInformationChange === void 0 ? void 0 : onFlowInformationChange(aiImageData);
    }, [setSelectedImageSize, prompt, selectedStyle, onFlowInformationChange]);
    const isPreviewMode = (0, react_1.useMemo)(() => previewUrl && !result && status === 'idle', [previewUrl, result, status]);
    return ((0, jsx_runtime_1.jsxs)(AiImageOverview_style_1.StyledEmbeddedContainer, { children: [(0, jsx_runtime_1.jsxs)(AiImageOverview_style_1.StyledWrapper, { isEmbedded: true, children: [result && view === 'preview' && status !== 'loading' && ((0, jsx_runtime_1.jsx)(components_1.AppPreview, { isEmbedded: true, title: status === 'error' ? result : prompt || '', type: status === 'success' ? 'image' : 'text', labels: labels, status: status, result: result, onClick: () => { var _a; return insertNewAsset(result, { ratio: (_a = selectedImageSize === null || selectedImageSize === void 0 ? void 0 : selectedImageSize.ratio) !== null && _a !== void 0 ? _a : 1 }); }, allowRegenerate: allowRegenerate, onChangeView: () => setView('edit'), children: status === 'success' && imagePreview && ((0, jsx_runtime_1.jsx)(components_1.AppImagePreview, { onClick: () => {
                                var _a;
                                return insertNewAsset(result, {
                                    ratio: (_a = selectedImageSize === null || selectedImageSize === void 0 ? void 0 : selectedImageSize.ratio) !== null && _a !== void 0 ? _a : 1,
                                });
                            }, children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Image, { source: imagePreview, rounded: true }) })) })), previewUrl &&
                        isPreviewMode &&
                        view === 'preview' &&
                        status !== 'loading' && ((0, jsx_runtime_1.jsx)(components_1.AppPreview, { isEmbedded: true, title: prompt || '', type: 'image', labels: labels, status: status, result: previewUrl, onClick: () => {
                            var _a;
                            return insertNewAsset(previewUrl, {
                                ratio: (_a = selectedImageSize === null || selectedImageSize === void 0 ? void 0 : selectedImageSize.ratio) !== null && _a !== void 0 ? _a : 1,
                            });
                        }, allowRegenerate: false, onChangeView: () => setView('edit'), children: (0, jsx_runtime_1.jsx)(components_1.AppImagePreview, { onClick: () => {
                                var _a;
                                return insertNewAsset(previewUrl, {
                                    ratio: (_a = selectedImageSize === null || selectedImageSize === void 0 ? void 0 : selectedImageSize.ratio) !== null && _a !== void 0 ? _a : 1,
                                });
                            }, children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Image, { source: previewUrl, rounded: true }) }) })), (0, jsx_runtime_1.jsx)(components_1.AppContent, { isLoading: status === 'loading', isEmbedded: true, children: view === 'edit' && ((0, jsx_runtime_1.jsx)(components_1.AppForm, { inputRef: textAreaRef, labels: labels, result: result !== null && result !== void 0 ? result : undefined, showSubtitle: ['idle', 'error'].includes(status), status: status, prompt: prompt || '', onPromptChange: handlePromptChange, onPromptSubmit: (prompt) => onSubmit(prompt, {
                                style: selectedStyle,
                                size: (selectedImageSize === null || selectedImageSize === void 0 ? void 0 : selectedImageSize.value) || '',
                            }) })) }), view === 'edit' && status !== 'loading' && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [imageSizes && ((0, jsx_runtime_1.jsx)(AiImageStyles_1.AiImageSize, { title: labels.aspectRatio, items: imageSizes, selectedSize: selectedImageSize, onClick: (item) => {
                                    handleSizeChange(item);
                                } })), (0, jsx_runtime_1.jsx)(AiImageStyles_1.AiImageStyles, { title: labels.chooseStyle, maxStyles: ['success', 'error'].includes(status) ? 3 : 6, labelSeeMore: labels.seeMore, labelSeeLess: labels.seeLess, styles: imageStyles, selectedStyle: selectedStyle, onStyleChange: handleStyleChange, stylesOpened: stylesOpened, setStylesOpened: handleSeeMoreStyles })] }))] }), status === 'loading' ||
                isPreviewMode ||
                (!allowRegenerate && status !== 'idle') || ((0, jsx_runtime_1.jsx)(components_1.AppFooter, { isEmbedded: true, children: (0, jsx_runtime_1.jsx)(components_1.AppButtons, { isEmbedded: true, labels: labels, status: status, prompt: prompt, onSubmit: (prompt) => onSubmit(prompt, {
                        style: selectedStyle,
                        size: (selectedImageSize === null || selectedImageSize === void 0 ? void 0 : selectedImageSize.value) || '',
                    }), onCancel: onCancel, onClear: onClear, view: view }) }))] }));
}
exports.AiImageEmbeddedOverview = AiImageEmbeddedOverview;
//# sourceMappingURL=AiImageEmbeddedOverview.js.map